module.exports = __webpack_public_path__ + "img/wuhai-f2147f.png";